import { ESTADOS } from "#colaborador/Solicitudes/constants"
import { MasterDialog } from "#common/Dialog/Dialog"
import InputText from "#common/input/InputText"
import { useApiSend } from "#hooks/useApiSend"
import { UseSavingsFundContext } from "#savings-fund/contexts/contexts"
import { savingFundPut } from "#savings-fund/services/Api"
import { Stack, Typography } from "@mui/material"
import { useState } from "react"
import { toast } from "react-toastify"

export default function TableDialog({ saving_id, status, setOpen, open }) {
	const { refreshData } = UseSavingsFundContext()
	const [message, setMessage] = useState("")
	const [dateExit, setDateExit] = useState("")
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		setOpen(false)
		refreshData()
	}
	const { cancelar, fetch } = useApiSend(savingFundPut, {
		success,
		end: () => setDisabled(false),
	})

	const handleApproved = () => {
		if (status === ESTADOS.RECHAZADO) {
			if (message.trim() === "") {
				toast.error(`Agrega un comentario para el rechazo`)
				return false
			}
		} else if (status === ESTADOS.FINALIZADO)
			if (dateExit.trim() === "") {
				toast.error(`Selecciona una fecha de salida `)
				return false
			}
		setDisabled(true)
		fetch(saving_id, { status, dateExit, message })
	}

	const contenido = {
		[ESTADOS.RECHAZADO]: (
			<Stack spacing={2} justifyContent="center" alignItems="center">
				<strong>¿Rechazar Solicitud?</strong>
				<InputText id="message" label="Comentario" setValue={setMessage} />
			</Stack>
		),
		[ESTADOS.APROBADO]: (
			<Typography variant="h6" align="center">
				<strong>¿Aprobar Solicitud?</strong>
			</Typography>
		),
	}
	let onClose = () => {
		setOpen(false)
		setMessage("")
		setDateExit("")
	}

	let buttons = [
		{
			label: "cancelar",
			onClick: () => {
				cancelar()
				onClose()
			},
		},
		{ label: "aceptar", onClick: handleApproved, disabled },
	]

	return (
		<MasterDialog open={!!open} onClose={onClose} maxWidth="xs" buttons={buttons}>
			{contenido[status]}
		</MasterDialog>
	)
}
